<div class="flex-col-center">
    <div class="flex-row-container">
        <mat-form-field style="width:400px;">
            <mat-icon matSuffix>search</mat-icon>
            <input  type="text" 
            placeholder="Client or Account Search" 
            aria-label="Client Search" 
            maxlength="30"
            matInput
            style="padding-left: 10px;"
            [formControl]="searchControl" 
            [matAutocomplete]="auto" 
            *ngIf="clientList">
            <mat-autocomplete #auto="matAutocomplete" [panelWidth]="500" class="client-search-autocomplete">
                    <div class="p-10 search__header B">
                        <span>Clients (</span><span>{{((clientList['@odata.count']>=5)? ('5'):(clientList['@odata.count']))}}</span><span> of {{clientList['@odata.count']}})</span>
                    </div>
                    <mat-option  *ngFor="let c of clientList['value']"  [value]="" (onSelectionChange)="onClientSelectionChange(c)">                          
                    <div style="display: flex; flex-direction: row; justify-content: space-between;"  [ngClass]="!(c.legalEntityType==='Individual' || c.legalEntityType==='P')?'red-text':''">
                        <div class="search__advisorId-column"> 
                            <span><mat-icon matPrefix  [ngClass]="!(c.legalEntityType==='Individual' || c.legalEntityType==='P')?'red-text':''">person</mat-icon></span>
                        </div>
                        <div class="search__name-column">
                        <span class="text-truncate">{{c.LegalEntityName}}</span>
                        <span style="font-size: 10px;"><span class="B">{{c.Account.length}}</span> Account(s)</span>   
                        </div>
                        <div class="search__name-column">
                        <span class="text-truncate">{{c.ClientAdvisor}}</span>
                        <span class="text-truncate">{{c.ClientAdvisorTeam}}</span>
                        </div>
                        <div class="search__advisorId-column">
                            <span>{{c.ClientAdvisorID}}</span>
                        </div>
                        <div class="search__amount-column" style="align-items: flex-end;">
                            <span>{{c.ClientKPI && c.ClientKPI.AumTotal | currency }}</span>                             
                        </div>
                    </div>
                    </mat-option> 
                    <div class="p-10 search__header B">
                        <span>Accounts (</span><span>{{((accountList['@odata.count']>=5)? ('5'):(accountList['@odata.count']))}}</span><span> of {{accountList['@odata.count']}})</span>
                    </div>
                    <mat-option  *ngFor="let c of accountList['value']"  [value]="" (onSelectionChange)="onAccountSelectionChange(c)">                          
                    <div style="display: flex; flex-direction: row; justify-content: space-between;" [ngClass]="!(c.legalEntityType==='Individual' || c.legalEntityType==='P')?'red-text':''">
                        <div class="advisorId-column"> 
                            <span><mat-icon matPrefix [ngClass]="!(c.legalEntityType==='Individual' || c.legalEntityType==='P')?'red-text':''">account_balance</mat-icon></span>
                        </div>
                        <div class="search__name-column">
                        <span *ngIf="c.CustodianType && c.CustodianType.toUpperCase()==='INTERNAL'" class="text-truncate">{{(c.gfoCustodyAccount && c.CustodyAccount)?c.CustodyAccount:(c.id | uppercase)}}</span>
                        <span *ngIf="c.CustodianType && c.CustodianType.toUpperCase()==='EXTERNAL'" class="text-truncate">{{c.AccountNickname | uppercase}}</span>                                  
                        </div>
                        <div class="search__name-column">
                        <span class="text-truncate">{{c.ClientAdvisor}}</span>
                        <span class="text-truncate">{{c.ClientAdvisorTeam}}</span>
                        </div>
                        <div class="search__advisorId-column">
                            <span class="text-truncate">{{c.ClientAdvisorID}}</span>
                        </div>
                        <div class="search__amount-column" style="align-items: flex-end;">
                            <span class="text-truncate">{{c.AccountKPIs && c.AccountKPIs.AccountTotal | currency }}</span>                             
                        </div>
                    </div>
                    </mat-option>                                                 
            </mat-autocomplete>
        </mat-form-field>
        <mat-icon style="color: #800040;" class="pointer m-l10 m-t10 B" matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Close Search" (click)="onCloseSearch()">close</mat-icon>
    </div>
</div>     
  